import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["alt", "src"]
const _hoisted_2 = { class: "text-nowrap lh-1 mb-0" }
const _hoisted_3 = { class: "small lh-1" }
const _hoisted_4 = { class: "rank-line lh-1" }
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = {
  class: "h4",
  title: "Volumen Otorgado"
}
const _hoisted_7 = { class: "member-footer d-flex flex-row flex-grow-1 text-center border-top border-end-0" }
const _hoisted_8 = { class: "border-end flex-grow-1" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "border-end flex-grow-1" }
const _hoisted_11 = { class: "align-top" }
const _hoisted_12 = { class: "border-end flex-grow-1" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "border-end flex-grow-1" }
const _hoisted_15 = { class: "align-top" }
const _hoisted_16 = { class: "align-top" }
const _hoisted_17 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rank_icon = _resolveComponent("rank-icon")!
  const _component_package_icon = _resolveComponent("package-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["border border-1 mb-2 overflow-hidden member-tile", _ctx.isVIP ? 'border-gold' : ''])
  }, [
    (_ctx.memberData)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
        'd-flex border-bottom-0 member-card',
        { 'justify-content-end': _ctx.teamSide == 'left' },
        _ctx.backgroundColor,
        _ctx.teamSide,
      ]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTeamLeader(_ctx.memberData.usernamePK)))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.picSideClass + ' flex-row d-flex align-self-start')
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([
            _ctx.bgSideClass,
            'position-relative member-photo p-2',
            { 'flip-bg': _ctx.teamSide === 'right' },
          ]),
              style: _normalizeStyle(
            _ctx.rankBackground ? '--rank-bg: url(' + _ctx.rankBackground + ');' : ''
          )
            }, [
              _createElementVNode("img", {
                alt: _ctx.memberData.nickname,
                src: _ctx.profilePic,
                class: _normalizeClass(["rounded-circle img-fluid gtr-avatar-bg", [
              _ctx.photoSideClass,
              _ctx.teamSide,
              _ctx.isVIP ? 'vip-stroke vip-shadow' : '',
            ]])
              }, null, 10, _hoisted_1)
            ], 6)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([
          'flex-grow-1 text-center mx-4 px-3 align-self-center',
          _ctx.dataSideClass,
        ])
          }, [
            _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.memberData.nickname), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.memberData.username), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", {
                class: "rank-ico-slot",
                style: _normalizeStyle({ color: _ctx.rankColor })
              }, [
                _createVNode(_component_rank_icon, {
                  "icon-class": _ctx.userRank?.iconClass,
                  "extra-class": "fa-fw"
                }, null, 8, ["icon-class"])
              ], 4),
              _createTextVNode(_toDisplayString(_ctx.userRank?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.teamSide == 'left')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass([
              'fas me-2',
              {
                'fa-exclamation-triangle text-warning':
                  Number(_ctx.memberData.points?.qualifying) > _ctx.maxPointsPerUser,
              },
            ])
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_6, _toDisplayString(Number(_ctx.memberData.points?.qualifying).toLocaleString()), 1),
              (_ctx.teamSide == 'right')
                ? (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: _normalizeClass([
              'fas ms-2',
              {
                'fa-exclamation-triangle text-warning':
                  Number(_ctx.memberData.points?.qualifying) > _ctx.maxPointsPerUser,
              },
            ])
                  }, null, 2))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(['d-flex flex-row flex-grow-1', _ctx.memberBriefClass])
      }, [
        (_ctx.isAcademyLevel)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_package_icon, {
                  product: _ctx.currentUserPackage,
                  "extra-class": "me-2"
                }, null, 8, ["product"]),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.remainigDaysTradingAcademy), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_package_icon, {
                  product: "license",
                  "extra-class": "me-2"
                }),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.remainigDaysDistributor), 1)
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isLite)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_package_icon, {
                  product: _ctx.currentUserPackage,
                  "extra-class": "me-2"
                }, null, 8, ["product"]),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.gtrLiteDaysLeft), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_package_icon, {
                  product: "license",
                  "extra-class": "me-2"
                }),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.liteDistributorDaysLeft), 1)
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["flex-grow-1", _ctx.teamSide == 'left' ? 'border-end' : ''])
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-diagram-project me-2" }, null, -1)),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.memberData.directAffiliates), 1)
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(['d-flex flex-row flex-grow-0', _ctx.memberShortcutsClass])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex-grow-1 px-3", _ctx.teamSide == 'left' ? 'border-end' : '']),
          title: _ctx.refreshing ? 'Actualizando...' : 'Actualizar datos',
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.refreshMember && _ctx.refreshMember(...args)), ["stop"]))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass([
              'fas fa-arrow-rotate-right text-secondary',
              { spin: _ctx.refreshing },
            ])
          }, null, 2)
        ], 10, _hoisted_17)
      ], 2)
    ])
  ], 2))
}